import Style from "./CheckoutPayment.module.scss";
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useCardsCheckout } from "../../../logic/useCardsCheckout";
import { useNavigate, useParams } from "react-router-dom";
import GooglePayButton from "@google-pay/button-react";
import { useGpay } from "../../../logic/useGpay";
import GpaySvg from "./gpay.png";
import { CreditCard } from "react-feather";

const CheckoutPayment = ({ data }) => {
  const REACT_APP_CHECKOUT_PUBLIC_KEY =
    process.env.REACT_APP_PRODUCTION === "true"
      ? process.env.REACT_APP_CHECKOUT_PUBLIC_KEY
      : process.env.REACT_APP_CHECKOUT_TEST_PUBLIC_KEY;

  const REACT_APP_GPAY_MERCHANT_ID = process.env.REACT_APP_GPAY_MERCHANT_ID;

  const REACT_APP_GPAY_MERCHANT_NAME = process.env.REACT_APP_GPAY_MERCHANT_NAME;

  const {
    payButtonDisabled,
    submitPayment,
    flowReady,
    cancelButton,
    loadingShimmer,
    errorMsgCard,
  } = useCardsCheckout({ ...data });

  const { gPayApi, gpayLoader, errorMsg } = useGpay(data);

  const { t } = useTranslation(["common"]);

  const navigate = useNavigate();

  const { lang: langSlug } = useParams();

  useEffect(() => {
    if (!langSlug) {
      const lang = localStorage.getItem("language_type");
      if (lang === "ar") {
        navigate("/ar");
      } else if (lang === "en") {
        navigate("/en");
      } else {
        navigate("/en");
      }
    }
  }, []);

  const paymentRequest = {
    apiVersion: 2,
    apiVersionMinor: 0,
    allowedPaymentMethods: [
      {
        type: "CARD",
        parameters: {
          allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
          allowedCardNetworks: ["MASTERCARD", "VISA"],
        },
        tokenizationSpecification: {
          type: "PAYMENT_GATEWAY",
          parameters: {
            gateway: "checkoutltd",
            gatewayMerchantId: REACT_APP_CHECKOUT_PUBLIC_KEY,
          },
        },
      },
    ],
    merchantInfo: {
      merchantId: REACT_APP_GPAY_MERCHANT_ID,
      merchantName: REACT_APP_GPAY_MERCHANT_NAME,
    },
    transactionInfo: {
      totalPriceStatus: "FINAL",
      totalPrice: data?.amount,
      currencyCode: "OMR",
      countryCode: "OM",
    },
  };

  return (
    <div className={Style.payment_detail}>
      <h5 className={`${Style.payment_detail_title} mb-0`}>
        {t("ENTER_PAYMENT_DETAILS")}
      </h5>

      <div className={Style.field_group}>
        {/* <div className={`${Style.field_wrapper} ${Style.credit_card}`}>
          <Form.Check
            type="radio"
            name="type"
            id="card"
            // defaultChecked={true}
            label={t("cardType")}
            onClick={() => {
              setCardClick(!cardClick);
              setGpayClick(false);
            }}
          />
          <CreditCard />
        </div> */}

        {/* )} */}
        {/* <div className={Style.field_wrapper}>
          <Form.Check
            type="radio"
            name="type"
            id="set_date"
            label={t("Gpay")}
            onClick={() => {
              setGpayClick(!gpayClick);
              setCardClick(false);
            }}
          />
          <img src={GpaySvg} alt="Gpay" />
        </div>
        {gpayClick ? (
          gpayLoader ? (
            <div className="col-5">
              <Button
                variant="primary"
                type="submit"
                className={` ${Style.payment_btn} loading`}
                id="payButton"
              >
                {t("PAY")}
              </Button>
            </div>
          ) : (
            <GooglePayButton
              environment="TEST"
              buttonType="short"
              paymentRequest={paymentRequest}
              onLoadPaymentData={(res) => gPayApi(res, data?.id)}
              buttonLocale={langSlug == "ar" ? "ar" : "en"}
            />
          )
        ) : (
          ""
        )} */}
        {errorMsgCard ? <div>{errorMsgCard}</div> : null}

        {errorMsg ? <div>{errorMsg}</div> : null}
      </div>
      {/* {cardClick && ( */}
      <div className={`row position-relative mt-3`}>
          <div className="col-12">
            {/* Flow card form mount point. The skeleton overlays it rather than
                replacing it: the container must stay laid out or Flow
                measures zero. No global `loading` class here — it sets
                pointer-events:none, which would deaden Flow's iframes. */}
            <div
              className={`${Style.methods} ${
                flowReady ? "" : Style.methods_loading
              }`}
            >
              {!flowReady && (
                <div className={Style.skeleton} aria-hidden="true">
                  <span className={`${Style.shimmer} ${Style.skeleton_label}`} />
                  <span className={`${Style.shimmer} ${Style.skeleton_field}`} />
                  <span className={`${Style.shimmer} ${Style.skeleton_label}`} />
                  <span className={`${Style.shimmer} ${Style.skeleton_field}`} />
                  <div className={Style.skeleton_row}>
                    <div className={Style.skeleton_col}>
                      <span
                        className={`${Style.shimmer} ${Style.skeleton_label}`}
                      />
                      <span
                        className={`${Style.shimmer} ${Style.skeleton_field}`}
                      />
                    </div>
                    <div className={Style.skeleton_col}>
                      <span
                        className={`${Style.shimmer} ${Style.skeleton_label}`}
                      />
                      <span
                        className={`${Style.shimmer} ${Style.skeleton_field}`}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div id="card-container" />
            </div>
          </div>
          <div className="col-12">
            <div className={Style.amount_summary}>
              {t("Total_amount")} :
              <span>
                <sup>{t("omr")}</sup>

                {parseFloat(data?.orginal_amount).toFixed(3)}
              </span>
            </div>
          </div>

          <div className="col-6">
            <button
              // variant="tertiary"
              type="submit"
              className={`${Style.payment_btn} custom_btn custom_btn-tertiary`}
              onClick={cancelButton}
            >
              {t("CANCEL")}
            </button>
          </div>

          <div className="col-6">
            <button
              // variant="primary"
              type="submit"
              className={
                loadingShimmer
                  ? ` ${Style.payment_btn} loading custom_btn custom_btn-primary`
                  : `${Style.payment_btn} custom_btn custom_btn-primary`
              }
              disabled={payButtonDisabled}
              id="payButton"
              onClick={submitPayment}
            >
              {t("PAY")}
            </button>
          </div>
      </div>
    </div>
  );
};

export default CheckoutPayment;
